import * as React from "react";
import { singleton } from "logic/singleton";
const NodesContext = React.createContext(void 0);
export default singleton("contexts.NodesContext", () => NodesContext);
